import presse1 from "../assets/img/presse1.png";
import presse2 from "../assets/img/presse2.png";
import presse3 from "../assets/img/presse3.png";
import presse4 from "../assets/img/presse4.png";
import presse5 from "../assets/img/presse5.png";

export const PRESSES = [
  {
    presseTitle: "Emission « Les grandes heures » – 2sTV – 14/11/2019",
    presseImg: presse1,
    preseLink: "https://www.youtube.com/watch?v=FzKztxk1Y2Y",
  },

  {
    presseTitle: " Seneweb – 13/07/2019",
    presseImg: presse2,
    preseLink:
      "https://www.seneweb.com/news/Societe/centre-de-defense-et-de-securite-un-labo_n_288170.html",
  },
  {
    presseTitle: "Emission Tribune Presse – SenTV – 04/03/2017",
    presseImg: presse3,
    preseLink:
      "http://www.yama.tv/sentv/video-dr-fally-camara-et-le-colonel-seyni-cisse-diop-dans-tribune-presse-du-samedi-04-mars-2017-sentv--116965/",
  },
  {
    presseTitle: "REWMI – 22/12/2016",
    presseImg: presse4,
    preseLink:
      "https://www.rewmi.com/intervention-militaire-senegal-gambie-operation-legitimement-attendue-colonel-seyni-cisse-diop.html",
  },
  {
    presseTitle: "Dakar Actu – 07/12/2015",
    presseImg: presse5,
    preseLink:
      "https://www.dakaractu.com/Securite-interieure-GS7S-s-engage-a-appuyer-les-organismes-militaires-et-paramilitaires-charges-d-assurer-directement-la_a102179.html",
  },
];
